var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"InfoWindow"}},[_c('div',{staticClass:"close-bar",on:{"click":_vm.handleClose}},[_c('button',[_vm._v("close x")])]),_vm._v(" "),_c('div',{staticClass:"inner-window"},[_c('InfoWindowHTML',{ref:"html"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }